import IconDescription from "@/components/IconDescription";
import { ProgramType } from "@/common/program/types";

type ExpertInstructionTranslate = (
  key:
    | "expertInstruction"
    | "graduateLevelCourses"
    | "skillBuildingCourses"
    | "highQualityCourses",
  values?: { count: number },
) => string;

export default function getExpertInstructionIcon(
  courseCount: number,
  programType: ProgramType,
  t: ExpertInstructionTranslate,
) {
  let subtitle = "";
  switch (programType) {
    case ProgramType.MICROMASTERS:
      subtitle = t("graduateLevelCourses", { count: courseCount });
      break;
    case ProgramType.PROFESSIONALCERTIFICATE:
      subtitle = t("skillBuildingCourses", { count: courseCount });
      break;
    default:
      subtitle = t("highQualityCourses", { count: courseCount });
  }
  return (
    <IconDescription
      iconType="program"
      title={t("expertInstruction")}
      subtitle={subtitle}
    />
  );
}
